import { createContext } from 'react';
import type { ReactElement } from 'react';

/** Runtime-only bridge; never serialized into a screen or payment configuration. */
export interface CustomPurchaseSlotInput {
  screenId: string;
  /** Owning CustomEmbed section; absent for standalone WebEmbed. */
  embedSectionId?: string;
  requestId: string;
  productId: string;
  childSectionId: string;
  signal: AbortSignal;
  /** Ephemeral same-origin iframe document; absent for Shadow DOM. */
  frameDocument?: Document;
  /** Stable authored host for layout reservation across product replacements. */
  layoutTarget?: Element;
  /** Runtime-only request-specific buyer control; it does not dispose this mount. */
  registerRequestClose?(requestClose: () => void): () => void;
  onReady(): void;
  onFallback(): void;
  /** Same-screen, one-shot receiver for a verified success after visual disposal.
   * Runtime-only: never transferred to another SDK instance or persisted. */
  onRecoveredSuccess?(): void;
  /** Exact original receiver for provider-confirmed unpaid retirement after disposal. */
  onRecoveredError?(message: string): void;
  /** Retire the SDK callback registration when its authored host disappears. */
  onDispose?(): void;
}
export type CustomPurchaseSlotRenderer = (input: CustomPurchaseSlotInput) => ReactElement;
export const CustomPurchaseSlotContext = createContext<CustomPurchaseSlotRenderer | null>(null);
export type CustomPurchaseSlotMount = (target: Element, input: Omit<CustomPurchaseSlotInput, 'screenId' | 'signal'>) => (() => void) | null;
